
export const UPDATE_NEWSCOMMENT = "UPDATE_NEWSCOMMENT"
export const UPDATE_NEWSCOMMENT_SUCCESS = "UPDATE_NEWSCOMMENT_SUCCESS"

export const UPDATE_JOB_ADVERTISEMENT = "UPDATE_JOB_ADVERTISEMENT"
export const UPDATE_JOB_ADVERTISEMENT_SUCCESS = "UPDATE_JOB_ADVERTISEMENT_SUCCESS"

export const DELETE_SUBEDUCATION = "DELETE_SUBEDUCATION"
export const DELETE_SUBEDUCATION_SUCCESS = "DELETE_SUBEDUCATION_SUCCESS"

export const UPDATE_SUBEDUCATION = "UPDATE_SUBEDUCATION"
export const UPDATE_SUBEDUCATION_SUCCESS = "UPDATE_SUBEDUCATION_SUCCESS"

export const ADD_SUBEDUCATION = "ADD_SUBEDUCATION"
export const ADD_SUBEDUCATION_SUCCESS = "ADD_SUBEDUCATION_SUCCESS"


export const GET_ABOUT_SUCCESS = "GET_ABOUT_SUCCESS"

export const UPDATE_EDUCATION_SUCCESS = "UPDATE_EDUCATION_SUCCESS"
export const UPDATE_EDUCATION = "UPDATE_EDUCATION"

export const ADD_EDUCATION = "ADD_EDUCATION"
export const ADD_EDUCATION_SUCCESS = "ADD_EDUCATION_SUCCESS"

export const GET_SUBEDUCATION = "GET_SUBEDUCATION"
export const GET_SUBEDUCATION_SUCCESS = "GET_SUBEDUCATION_SUCCESS"

export const ADD_SONG = "ADD_SONG"
export const ADD_SONG_SUCCESS = "ADD_SONG_SUCCESS"
export const UPDATE_SONG = "UPDATE_SONG"
export const UPDATE_SONG_SUCCESS = "UPDATE_SONG_SUCCESS"
export const GET_SONG_SUCCESS = "GET_SONG_SUCCESS"
export const GET_SONG= "GET_SONG"
export const DELETE_SONG = "DELETE_SONG"
export const DELETE_SONG_SUCCESS = "DELETE_SONG_SUCCESS"

export const ADD_NEWS_CATEGORY = "ADD_NEWS_CATEGORY"
export const ADD_NEWS_CATEGORY_SUCCESS = "ADD_NEWS_CATEGORY_SUCCESS"
export const UPDATE_NEWS_CATEGORY = "UPDATE_NEWS_CATEGORY"
export const UPDATE_NEWS_CATEGORY_SUCCESS = "UPDATE_NEWS_CATEGORY_SUCCESS"
export const GET_NEWS_CATEGORY_SUCCESS = "GET_NEWS_CATEGORY_SUCCESS"
export const GET_NEWS_CATEGORY= "GET_NEWS_CATEGORY"
export const DELETE_NEWS_CATEGORY = "DELETE_NEWS_CATEGORY"
export const DELETE_NEWS_CATEGORY_SUCCESS = "DELETE_NEWS_CATEGORY_SUCCESS"


export const ADD_NEWS = "ADD_NEWS"
export const ADD_NEWS_SUCCESS = "ADD_NEWS_SUCCESS"
export const UPDATE_NEWS = "UPDATE_NEWS"
export const UPDATE_NEWS_SUCCESS = "UPDATE_NEWS_SUCCESS"
export const GET_NEWS_SUCCESS = "GET_NEWS_SUCCESS"
export const GET_NEWS= "GET_NEWS"
export const DELETE_NEWS = "DELETE_NEWS"
export const DELETE_NEWS_SUCCESS = "DELETE_NEWS_SUCCESS"

export const GET_ADVERT = "GET_ADVERT"
export const GET_ADVERT_SUCCESS= "GET_ADVERT_SUCCESS"
export const UPDATE_ADVERT = "UPDATE_ADVERT"
export const UPDATE_ADVERT_SUCCESS = "UPDATE_ADVERT_SUCCESS"

export const DELETE_ADVERT = "DELETE_ADVERT"
export const DELETE_ADVERT_SUCCESS= "DELETE_ADVERT_SUCCESS"
export const ADD_ADVERT = "ADD_ADVERT"
export const ADD_ADVERT_SUCCESS = "ADD_ADVERT_SUCCESS"


export const GET_NEWS_COMMENT_SUCCESS = "GET_NEWS_COMMENT_SUCCESS"
export const GET_NEWS_COMMENT= "GET_NEWS_COMMENT"
export const DELETE_NEWS_COMMENT = "DELETE_NEWS_COMMENT"
export const DELETE_NEWS_COMMENT_SUCCESS = "DELETE_NEWS_COMMENT_SUCCESS"

export const ADD_JOB_ADVERTISEMENT_SUBCATEGORY = "ADD_JOB_ADVERTISEMENT_SUBCATEGORY"
export const ADD_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS = "ADD_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS"
export const UPDATE_JOB_ADVERTISEMENT_SUBCATEGORY = "UPDATE_JOB_ADVERTISEMENT_SUBCATEGORY"
export const UPDATE_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS = "UPDATE_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS"
export const GET_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS = "GET_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS"
export const GET_JOB_ADVERTISEMENT_SUBCATEGORY= "GET_JOB_ADVERTISEMENT_SUBCATEGORY"
export const DELETE_JOB_ADVERTISEMENT_SUBCATEGORY = "DELETE_JOB_ADVERTISEMENT_SUBCATEGORY"
export const DELETE_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS = "DELETE_JOB_ADVERTISEMENT_SUBCATEGORY_SUCCESS"

export const GET_JOB_ADVERTISEMENT_SUCCESS = "GET_JOB_ADVERTISEMENT_SUCCESS"
export const GET_JOB_ADVERTISEMENT= "GET_JOB_ADVERTISEMENT"
export const DELETE_JOB_ADVERTISEMENT = "DELETE_JOB_ADVERTISEMENT"
export const DELETE_JOB_ADVERTISEMENT_SUCCESS = "DELETE_JOB_ADVERTISEMENT_SUCCESS"

export const ADD_MAINPAGE_CATEGORY = "ADD_MAINPAGE_CATEGORY"
export const ADD_MAINPAGE_CATEGORY_SUCCESS = "ADD_MAINPAGE_CATEGORY_SUCCESS"
export const UPDATE_MAINPAGE_CATEGORY = "UPDATE_MAINPAGE_CATEGORY"
export const UPDATE_MAINPAGE_CATEGORY_SUCCESS = "UPDATE_MAINPAGE_CATEGORY_SUCCESS"
export const GET_MAINPAGE_CATEGORY_SUCCESS = "GET_MAINPAGE_CATEGORY_SUCCESS"
export const GET_MAINPAGE_CATEGORY= "GET_MAINPAGE_CATEGORY"
export const DELETE_MAINPAGE_CATEGORY = "DELETE_MAINPAGE_CATEGORY"
export const DELETE_MAINPAGE_CATEGORY_SUCCESS = "DELETE_MAINPAGE_CATEGORY_SUCCESS"

export const ADD_JOB_ADVERTISEMENT_CATEGORY = "ADD_JOB_ADVERTISEMENT_CATEGORY"
export const ADD_JOB_ADVERTISEMENT_CATEGORY_SUCCESS = "ADD_JOB_ADVERTISEMENT_CATEGORY_SUCCESS"
export const UPDATE_JOB_ADVERTISEMENT_CATEGORY = "UPDATE_JOB_ADVERTISEMENT_CATEGORY"
export const UPDATE_JOB_ADVERTISEMENT_CATEGORY_SUCCESS = "UPDATE_JOB_ADVERTISEMENT_CATEGORY_SUCCESS"
export const GET_JOB_ADVERTISEMENT_CATEGORY_SUCCESS = "GET_JOB_ADVERTISEMENT_CATEGORYY_SUCCESS"
export const GET_JOB_ADVERTISEMENT_CATEGORY= "GET_JOB_ADVERTISEMENT_CATEGORY"

export const DELETE_JOB_ADVERTISEMENT_CATEGORY = "DELETE_JOB_ADVERTISEMENT_CATEGORY"
export const DELETE_JOB_ADVERTISEMENT_CATEGORY_SUCCESS = "DELETE_JOB_ADVERTISEMENT_CATEGORY_SUCCESS"


export const ADD_SONG_CATEGORY = "ADD_SONG_CATEGORY"
export const ADD_SONG_CATEGORY_SUCCESS = "ADD_SONG_CATEGORY_SUCCESS"
export const UPDATE_SONG_CATEGORY = "UPDATE_SONG_CATEGORY"
export const UPDATE_SONG_CATEGORY_SUCCESS = "UPDATE_SONG_CATEGORY_SUCCESS"
export const GET_SONG_CATEGORY_SUCCESS = "GET_SONG_CATEGORY_SUCCESS"
export const GET_SONG_CATEGORY= "GET_SONG_CATEGORY"
export const DELETE_SONG_CATEGORY = "DELETE_SONG_CATEGORY"
export const DELETE_SONG_CATEGORY_SUCCESS = "DELETE_SONG_CATEGORY_SUCCESS"

export const ADD_ADVERTESING_FORM = "ADD_ADVERTESING_FORM"
export const ADD_ADVERTESING_FORM_SUCCESS = "ADD_ADVERTESING_FORM_SUCCESS"
export const UPDATE_ADVERTESING_FORM = "UPDATE_ADVERTESING_FORM"
export const UPDATE_ADVERTESING_FORM_SUCCESS = "UPDATE_ADVERTESING_FORM_SUCCESS"
export const GET_ADVERTESING_FORM_SUCCESS = "GET_ADVERTESING_FORM_SUCCESS"
export const GET_ADVERTESING_FORM= "GET_ADVERTESING_FORM"
export const DELETE_ADVERTESING_FORM = "DELETE_ADVERTESING_FORM"
export const DELETE_ADVERTESING_FORM_SUCCESS = "DELETE_ADVERTESING_FORM_SUCCESS"



export const ADD_ADVERTESING_CATEGORY = "ADD_ADVERTESING_CATEGORY"
export const ADD_ADVERTESING_CATEGORY_SUCCESS = "ADD_ADVERTESING_CATEGORY_SUCCESS"
export const UPDATE_ADVERTESING_CATEGORY = "UPDATE_ADVERTESING_CATEGORY"
export const UPDATE_ADVERTESING_CATEGORY_SUCCESS = "UPDATE_ADVERTESING_CATEGORY_SUCCESS"
export const GET_ADVERTESING_CATEGORY_SUCCESS = "GET_ADVERTESING_CATEGORY_SUCCESS"
export const GET_ADVERTESING_CATEGORY= "GET_ADVERTESING_CATEGORY"
export const DELETE_ADVERTESING_CATEGORY = "DELETE_ADVERTESING_CATEGORY"
export const DELETE_ADVERTESING_CATEGORY_SUCCESS = "DELETE_ADVERTESING_CATEGORY_SUCCESS"

export const ADD_ARTICLEDAY= "ADD_ARTICLEDAY"
export const ADD_ARTICLEDAY_SUCCESS = "ADD_ARTICLEDAY_SUCCESS"
export const UPDATE_ARTICLEDAY = "UPDATE_ARTICLEDAY"
export const UPDATE_ARTICLEDAY_SUCCESS = "UPDATE_ARTICLEDAY_SUCCESS"
export const GET_ARTICLEDAY_SUCCESS = "GET_ARTICLEDAY_SUCCESS"
export const GET_ARTICLEDAY= "GET_ARTICLEDAY"
export const DELETE_ARTICLEDAY = "DELETE_POOL"
export const DELETE_ARTICLEDAY_SUCCESS = "DELETE_ARTICLEDAY_SUCCESS"

export const ADD_POOL= "ADD_POOL"
export const ADD_POOL_SUCCESS = "ADD_POOL_SUCCESS"
export const UPDATE_POOL = "UPDATE_POOL"
export const UPDATE_POOL_SUCCESS = "UPDATE_POOL_SUCCESS"
export const GET_POOL_SUCCESS = "GET_POOL_SUCCESS"
export const GET_POOL= "GET_POOL"
export const DELETE_POOL = "DELETE_POOL"
export const DELETE_POOL_SUCCESS = "DELETE_POOL_SUCCESS"

export const ADD_FORUM= "ADD_FORUM"
export const ADD_FORUM_SUCCESS = "ADD_FORUM_SUCCESS"
export const UPDATE_FORUM = "UPDATE_FORUM"
export const UPDATE_FORUM_SUCCESS = "UPDATE_FORUM_SUCCESS"
export const GET_FORUM_SUCCESS = "GET_FORUM_SUCCESS"
export const GET_FORUM= "GET_FORUM"
export const DELETE_FORUM = "DELETE_FORUM"
export const DELETE_FORUM_SUCCESS = "DELETE_FORUM_SUCCESS"

export const ADD_SLIDER = "ADD_SLIDER"
export const ADD_SLIDER_SUCCESS = "ADD_SLIDER_SUCCESS"
export const UPDATE_SLIDER = "UPDATE_SLIDER"
export const UPDATE_SLIDER_SUCCESS = "UPDATE_SLIDER_SUCCESS"
export const GET_SLİDERS_SUCCESS = "GET_SLİDERS_SUCCESS"
export const GET_SLİDERS = "GET_SLİDERS"




export const ADD_COMPANY_CATEGORY = "ADD_COMPANY_CATEGORY"
export const ADD_COMPANY_CATEGORY_SUCCESS = "ADD_COMPANY_CATEGORY_SUCCESS"
export const UPDATE_COMPANY_CATEGORY = "UPDATE_COMPANY_CATEGORY"
export const UPDATE_COMPANY_CATEGORY_SUCCESS = "UPDATE_COMPANY_CATEGORY_SUCCESS"
export const GET_COMPANY_CATEGORY_SUCCESS = "GET_COMPANY_CATEGORY_SUCCESS"
export const GET_COMPANY_CATEGORY = "GET_COMPANY_CATEGORY"
export const DELETE_COMPANY_CATEGORY = "DELETE_COMPANY_CATEGORY"
export const DELETE_COMPANY_CATEGORY_SUCCESS = "DELETE_COMPANY_CATEGORY_SUCCESS"

export const ADD_COMPANY_SUBCATEGORY = "ADD_COMPANY_SUBCATEGORY"
export const ADD_COMPANY_SUBCATEGORY_SUCCESS = "ADD_COMPANY_SUBCATEGORY_SUCCESS"
export const UPDATE_COMPANY_SUBCATEGORY = "UPDATE_COMPANY_SUBCATEGORY"
export const UPDATE_COMPANY_SUBCATEGORY_SUCCESS = "UPDATE_COMPANY_SUBCATEGORY_SUCCESS"
export const GET_COMPANY_SUBCATEGORY_SUCCESS = "GET_COMPANY_SUBCATEGORY_SUCCESS"
export const GET_COMPANY_SUBCATEGORY = "GET_COMPANY_SUBCATEGORY"
export const DELETE_COMPANY_SUBCATEGORY = "DELETE_COMPANY_SUBCATEGORY"
export const DELETE_COMPANY_SUBCATEGORY_SUCCESS = "DELETE_COMPANY_SUBCATEGORY_SUCCESS"




export const ADD_COMPANY_ADVERT_PRICE = "ADD_COMPANY_ADVERT_PRICE"
export const ADD_COMPANY_ADVERT_PRICE_SUCCESS = "ADD_COADD_COMPANY_ADVERT_PRICE_SUCCESSMPANY_CATEGORY_SUCCESS"
export const UPDATE_COMPANY_ADVERT_PRICE = "UPDATE_COMPANY_ADVERT_PRICE"
export const UPDATE_COMPANY_ADVERT_PRICE_SUCCESS = "UPDATE_COMPANY_ADVERT_PRICE_SUCCESS"
export const GET_COMPANY_ADVERT_PRICE_SUCCESS = "GET_COMPANY_ADVERT_PRICE_SUCCESS"
export const GET_COMPANY_ADVERT_PRICE = "GET_COMPANY_ADVERT_PRICE"
export const DELETE_COMPANY_ADVERT_PRICE = "DELETE_COMPANY_ADVERT_PRICE"
export const DELETE_COMPANY_ADVERT_PRICE_SUCCESS = "DELETE_COMPANY_ADVERT_PRICE_SUCCESS"


export const ADD_NE = "ADD_NE"
export const ADD_NE_SUCCESS = "ADD_NE_SUCCESS"
export const UPDATE_NE= "UPDATE_NE"
export const UPDATE_NE_SUCCESS = "UPDATE_NE_SUCCESS"
export const GET_NE_SUCCESS = "GET_NE_SUCCESS"
export const GET_NE = "GET_NE"
export const DELETE_NE= "DELETE_NE"
export const DELETE_NE_SUCCESS = "DELETE_NE_SUCCESS"

export const ADD_COMPANY = "ADD_COMPANY"
export const ADD_COMPANY_SUCCESS = "ADD_COMPANY_SUCCESS"
export const UPDATE_COMPANY= "UPDATE_COMPANY"
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS"
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS"
export const GET_COMPANY = "GET_COMPANY"
export const DELETE_COMPANY= "DELETE_COMPANY"
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS"

export const GET_PRODUCTCATEGORY = "GET_PRODUCTCATEGORY"
export const GET_PRODUCTCATEGORY_SUCCESS = "GET_PRODUCTCATEGORY_SUCCESS"

export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"



export const GET_BLOGS = "GET_BLOGS"
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS"

export const GET_SSS = "GET_SSS"
export const GET_SSS_SUCCESS = "GET_SSS_SUCCESS"

export const DELETE_SSS = "DELETE_SSS"
export const DELETE_SSS_SUCCESS = "DELETE_SSS_SUCCESS"

export const GET_EDUCATION = "GET_EDUCATION"
export const GET_EDUCATION_SUCCESS = "GET_EDUCATION_SUCCESS"

export const DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS = "DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS"
export const DELETE_DYNAMICFORMEXTRAEXTRA = "DELETE_DYNAMICFORMEXTRAEXTRA"

export const DELETE_DYNAMICFORM = "DELETE_DYNAMICFORM"
export const DELETE_DYNAMICFORM_SUCCESS = "DELETE_DYNAMICFORM_SUCCESS"

export const DELETE_DYNAMICFORMEXTRA = "DELETE_DYNAMICFORMEXTRA"
export const DELETE_DYNAMICFORMEXTRA_SUCCESS = "DELETE_DYNAMICFORMEXTRA_SUCCESS"

export const DELETE_COURSESCHEDULES = "DELETE_COURSESCHEDULES"
export const DELETE_COURSESCHEDULES_SUCCESS = "DELETE_COURSESCHEDULES_SUCCESS"

export const ADD_GALLERYMULTIPLE = "ADD_GALLERYMULTIPLE"
export const ADD_GALLERYMULTIPLE_SUCCESS = "ADD_GALLERYMULTIPLE_SUCCESS"

export const DELETE_GALLERY = "DELETE_GALLERY"
export const DELETE_GALLERY_SUCCESS = "DELETE_GALLERY_SUCCESS"

export const ADD_GALLERY = "ADD_GALLERY"
export const ADD_GALLERY_SUCCESS = "ADD_GALLERY_SUCCESS"


export const ADD_PRODUCTCATEGORY = "ADD_PRODUCTCATEGORY"
export const ADD_PRODUCTCATEGORY_SUCCESS = "ADD_PRODUCTCATEGORY_SUCCESS"



export const ADD_SSS = "ADD_SSS"
export const ADD_SSS_SUCCESS = "ADD_SSS_SUCCESS"


export const ADD_BLOG= "ADD_BLOG"
export const ADD_BLOG_SUCCESS = "ADD_BLOG_SUCCESS"

export const DELETE_REFERANCES = "DELETE_REFERANCES"
export const DELETE_REFERANCES_SUCCESS = "DELETE_REFERANCES_SUCCESS"

export const DELETE_POPUP = "DELETE_POPUP"
export const DELETE_POPUP_SUCCESS = "DELETE_POPUP_SUCCESS"

export const DELETE_PRODUCTCATEGORY_SUCCESS = "DELETE_PRODUCTCATEGORY_SUCCESS"
export const DELETE_PRODUCTCATEGORY = "DELETE_PRODUCTCATEGORY"

export const ADD_USER= "ADD_USER"
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS"


export const ADD_PRODUCT= "ADD_PRODUCT"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"

export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"

export const UPDATE_SSS= "UPDATE_SSS"
export const UPDATE_SSS_SUCCESS = "UPDATE_SSS_SUCCESS"

export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT = "DELETE_PRODUCT"




export const DELETE_BLOG_SUCCESS = "DELETE_BLOG_SUCCESS"
export const DELETE_BLOG = "DELETE_BLOG"


export const DELETE_MEGA_SUCCESS = "DELETE_MEGA_SUCCESS"
export const DELETE_MEGA = "DELETE_MEGA"
export const ADD_MEGA_SUCCESS = "ADD_MEGA_SUCCESS"

export const GET_DYNAMICFORM_EXTRA_EXTRA = "GET_DYNAMICFORM_EXTRA_EXTRA"
export const GET_DYNAMICFORMEXTRAEXTRA_SUCCESS = "GET_DYNAMICFORMEXTRAEXTRA_SUCCESS"
export const GET_DYNAMICFORMEXTRA_SUCCESS = "GET_DYNAMICFORMEXTRA_SUCCESS"
export const GET_DYNAMICFORM_EXTRA = "GET_DYNAMICFORM_EXTRA"
export const GET_CLASSES_SUCCESS = "GET_CLASSES_SUCCESS"
export const GET_CLASSES = "GET_CLASSES"
export const GET_USERS = "GET_USERS"
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS"
export const GET_USERS_FAIL = "GET_USERS_FAIL"


export const GET_GALLERY_SUCCESS = "GET_GALLERY_SUCCESS"
export const GET_GALLERY = "GET_GALLERY"

export const UPDATE_WORKSHOP2_SUCCESS = "UPDATE_WORKSHOP2_SUCCESS"

export const UPDATE_SUBDOMAIN = "UPDATE_SUBDOMAIN"



export const UPDATE_PROJECT = "UPDATE_PROJECT"

export const UPDATE_DYNAMICFORM = "UPDATE_DYNAMICFORM"
export const GET_DYNAMICFORM_SUCCESS = "GET_DYNAMICFORM_SUCCESS"
export const UPDATE_DYNAMICFORM_SUCCESS = "UPDATE_DYNAMICFORM_SUCCESS"


export const ADD_DYNAMICFORM_SUCCESS = "ADD_DYNAMICFORM_SUCCESS"



export const UPDATE_SUCCESS_PROJECT = "UPDATE_SUCCESS_PROJECT"
export const UPDATE_SUCCESS_GALLERY = "UPDATE_SUCCESS_GALLERY"

export const UPDATE_COURSESCHEDULES = "UPDATE_COURSESCHEDULES"
export const UPDATE_SUBDOMAIN_SUCCESS = "UPDATE_SUBDOMAIN_SUCCESS"
export const UPDATE_WORKSHOPSESSION_SUCCESS = "UPDATE_WORKSHOPSESSION_SUCCESS"
export const UPDATE_SUCCESS_COURSESCHEDULES = "UPDATE_SUCCESS_COURSESCHEDULES"
export const UPDATE_SUCCESS_TEACHER = "UPDATE_SUCCESS_TEACHER"

export const UPDATE_SUCCESS_NEWS = "UPDATE_SUCCESS_NEWS"
export const UPDATE_SUCCESS_MEGA = "UPDATE_SUCCESS_MEGA"
export const UPDATE_MEGA = "UPDATE_MEGA"
export const UPDATE_WORKSHOP2 = "UPDATE_WORKSHOP2"
export const UPDATE_GALLERY = "UPDATE_GALLERY"
export const UPDATE_REFERANCES = "UPDATE_REFERANCES"
export const UPDATE_REFERANCES_SUCCESS = "UPDATE_REFERANCES_SUCCESS"

export const UPDATE_BLOG = "UPDATE_BLOG"
export const UPDATE_BLOG_SUCCESS = "UPDATE_BLOG_SUCCESS"
export const UPDATE_PRODUCTCATEGORY = "UPDATE_PRODUCTCATEGORY"
export const UPDATE_PRODUCTCATEGORY_SUCCESS = "UPDATE_PRODUCTCATEGORY_SUCCESS"
export const GET_TEACHER_WORKSHOP = "GET_TEACHER_WORKSHOP"
export const GET_WORKSHOP2_SUCCESS = "GET_WORKSHOP2_SUCCESS"
export const GET_SUBPROJECT_SUCCESS = "GET_SUBPROJECT_SUCCESS"



export const GET_AUTHORITY = "GET_AUTHORITY"
export const GET_CONTACT = "GET_CONTACT"
export const GET_ABOUT = "GET_ABOUT"
export const UPDATE_CONTACT = "UPDATE_CONTACT"
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS"
export const UPDATE_ABOUT = "UPDATE_ABOUT"
export const UPDATE_ABOUT_SUCCESS = "UPDATE_ABOUT_SUCCESS"

export const GET_AUTH_SUCCESS = "GET_AUTH_SUCCESS"
export const UPDATE_AUTH = "UPDATE_AUTH"
export const GET_WORKSHOP2 = "GET_WORKSHOP2"
export const GET_REFERANCES = "GET_REFERANCES"
export const GET_REFERANCES_SUCCESS = "GET_REFERANCES_SUCCESS"
export const ADD_REFERANCES = "ADD_REFERANCES"
export const ADD_REFERANCES_SUCCESS = "ADD_REFERANCES_SUCCESS"
export const ADD_DYNAMIC_FORM = "ADD_DYNAMIC_FORM"



export const DELETE_SLIDER_SUCCESS = "DELETE_SLIDER_SUCCESS"
export const DELETE_SLIDER = "DELETE_SLIDER"

export const GET_AUTHUPDATE_SUCCESS = "GET_AUTHUPDATE_SUCCESS"
export const GET_SUBPROJECT = "GET_SUBPROJECT"
export const GET_CLASSATTENDANCE = "GET_CLASSATTENDANCE"
export const GET_CLASSATTENDANCE_SUCCESS = "GET_CLASSATTENDANCE_SUCCESS"

export const UPDATE_LESSONS_TIME = "UPDATE_LESSONS_TIME"
export const ADD_LESSONSTIME_SUCCESS = "ADD_LESSONSTIME_SUCCESS"
export const ADD_LESSONS_TIME = "ADD_LESSONS_TIME"
export const ADD_WORKSHOP2 = "ADD_WORKSHOP2"
export const ADD_APPSETTING = "ADD_APPSETTING"
export const ADD_WORKSHOPSUBDOMAIN = "ADD_WORKSHOPSUBDOMAIN"
export const ADD_COURSE = "ADD_COURSE"
export const ADD_MEGA = "ADD_MEGA"

export const ADD_PROJECT = "ADD_PROJECT"

export const ADD_POPUP = "ADD_POPUP"
export const UPDATE_TEACHER = "UPDATE_TEACHER"
export const UPDATE_WORKSHOPSESSION = "UPDATE_WORKSHOPSESSION"
export const UPDATE_POPUP = "UPDATE_POPUP"
export const GET_POPUP_SUCCESS = "GET_POPUP_SUCCESS"
export const UPDATE_POPUP_SUCCESS = "UPDATE_POPUP_SUCCESS"
export const GET_TEACHERWORKSHOP_SUCCESS = "GET_TEACHERWORKSHOP_SUCCESS"
export const UPDATE_LESSONSTIME_SUCCESS = "UPDATE_LESSONSTIME_SUCCESS"

export const GET_WORKSHOP_SUCCESS = "GET_WORKSHOP_SUCCESS"
export const GET_WORKSHOPSESSION_SUCCESS = "GET_WORKSHOPSESSION_SUCCESS"
export const GET_APPLICATION_SUCCESS = "GET_APPLICATION_SUCCESS"

export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS"

export const GET_MEGA_SUCCESS = "GET_MEGA_SUCCESS"
export const GET_TEACHER_SUCCESS = "GET_TEACHER_SUCCESS"
export const GET_DYNAMIC_SUCCESS = "GET_DYNAMIC_SUCCESS"

/* POPUP */
export const GET_POPUP = "GET_POPUP"
export const GET_WORKSHOP = "GET_WORKSHOP"
export const GET_CourseSchedulesMega = "GET_CourseSchedulesMega"
export const GET_WorkshopSessionMega = "GET_WorkshopSessionMega"
export const GET_TeacherMega = "GET_TeacherMega"
export const GET_EVENT = "GET_EVENT"
export const GET_DYNAMICFORM = "GET_DYNAMICFORM"

export const GET_PROJECTSNEW = "GET_PROJECTSNEW"

export const GET_MEGA = "GET_MEGA"

/* USERS PROFILE */
export const GET_USER_PROFILE = "GET_USER_PROFILE"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL"


/**
 * add user
 */


/**
 * Edit user
 */
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL"

/**
 * Delete user
 */
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAIL = "DELETE_USER_FAIL"
